var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolderEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M20.938 6.833h-8.25L9.938 4H3.061C1.923 4 1 4.951 1 6.125v12.75C1 20.049 1.923 21 3.063 21h17.875C22.076 21 23 20.049 23 18.875V8.958c0-1.173-.923-2.125-2.063-2.125zm-4.186 4.664l-.81.81a.212.212 0 01-.3 0l-1.95-1.951a.212.212 0 010-.3l.81-.81a.847.847 0 011.194 0l1.056 1.057c.33.329.33.863 0 1.194zm-3.756-.744l-4.617 4.616-.372 2.136c-.051.288.2.538.488.489l2.136-.375 4.616-4.616a.21.21 0 000-.299l-1.95-1.951a.213.213 0 00-.301 0zm-3.45 5.7h.844v.637l-1.134.199-.546-.547.198-1.134h.639v.844z"
  }))));
}

export default SvgFolderEdit;